import type { Borrower, BtlApplication, Individual } from './types';

export function getSortedIndividualsForDisplay(borrower: Borrower): Individual[] {
  const individuals = [...borrower.individuals];
  const { individualOrder } = borrower;

  if (individualOrder.length === individuals.length && individuals.length > 0) {
    individuals.sort((a, b) => individualOrder.indexOf(a.id) - individualOrder.indexOf(b.id));
    return individuals;
  }

  individuals.sort((a, b) => {
    const aPrimary = Number(a.isPrimary);
    const bPrimary = Number(b.isPrimary);
    return bPrimary - aPrimary;
  });

  return individuals;
}

export function getPrimaryIndividual(borrower: Borrower): Individual | undefined {
  return getSortedIndividualsForDisplay(borrower)[0];
}

export function resolveBtlCaseDisplayName(application: BtlApplication): string {
  const primaryIndividual = getPrimaryIndividual(application.borrower);
  if (primaryIndividual?.lastName) {
    return primaryIndividual.lastName;
  }

  const company = application.borrower.companies[0];
  if (company?.companyName) {
    return company.companyName;
  }

  const titlePrefix = application.title.split(' -')[0];
  return titlePrefix !== application.referenceNumber ? titlePrefix : 'Case Summary';
}
